module.exports = __webpack_public_path__ + "images/puzzle/Skeleton/PNG/Piece04.8593ae640990570ad846b84e372e0d78.png";